import { useHeaderScroll } from "../../hooks/useHeaderScroll";

type HeaderProps = {
  onNavigate?: (target: "home" | "villages" | "interviewees") => void;
  isHero?: boolean;
  activeNav?: "home" | "villages" | "interviewees";
};

export function Header({ onNavigate, isHero = false, activeNav = "home" }: HeaderProps) {
  const isScrolled = useHeaderScroll(60);
  const isSolid = !isHero || isScrolled;

  function handleClick(target: "home" | "villages" | "interviewees", e: React.MouseEvent) {
    e.preventDefault();
    onNavigate?.(target);
  }

  return (
    <header className={`site-header${isSolid ? " is-solid" : ""}`}>
      <div className="site-header__inner">
        <div className="site-header__left">
          <a href="/" className="site-logo" aria-label="Rohingya Maps home" onClick={(e) => handleClick("home", e)}>
            <img className="site-logo__image" src="/logo.png" alt="Rohingya Maps logo" />
          </a>
        </div>

        <nav className="site-nav" aria-label="Main navigation">
          <a href="/" className={`site-nav__link${activeNav === "home" ? " is-active" : ""}`} onClick={(e) => handleClick("home", e)}>Home</a>
          <a href="/" className={`site-nav__link${activeNav === "villages" ? " is-active" : ""}`} onClick={(e) => handleClick("villages", e)}>Villages</a>
          <a href="/" className={`site-nav__link${activeNav === "interviewees" ? " is-active" : ""}`} onClick={(e) => handleClick("interviewees", e)}>Survivors</a>
        </nav>

        <div className="site-header__right">
          <button type="button" className="site-header__action">
            Get Involved
          </button>
        </div>
      </div>
    </header>
  );
}
